function initMediaHover() {
    // superkoders modernizr
    var className = document.documentElement.className;
    className = className.replace('no-js', 'js');

    (function () {
        var mediaHover = window.matchMedia('(hover: none), (pointer: coarse), (pointer: none)');
        mediaHover.addListener(function (media) {
            document.documentElement.classList[media.matches ? 'add' : 'remove']('no-hoverevents');
            document.documentElement.classList[!media.matches ? 'add' : 'remove']('hoverevents');
        });
        className += (mediaHover.matches ? ' no-hoverevents' : ' hoverevents');
    })();

    document.documentElement.className = className;
}
initMediaHover();
export default initMediaHover;